module.exports = __webpack_public_path__ + "img/shop-bottom.dfed0d6c.png";